import { makeStyles } from '@material-ui/core/styles';
import { SecondaryColors } from '@/utils/constants';

const useCardListSliderStyles = makeStyles(
  (muiTheme) => ({
    sliderCard: {
      width: '260px !important',
      textAlign: 'left',
      display: 'block',
      borderRadius: '4px',
      overflow: 'hidden',
      height: 'auto !important',
    },
    buttonSlide: {
      height: '100%',
      width: '100%',
      '&:hover div.rich-text': {
        color: SecondaryColors.main,
      },
    },
    swiperCarousel: {
      '& .swiper-wrapper': {
        display: 'flex',
        alignItems: 'stretch',
      },
      '& .swiper-container': {
        '&.swiper-shadow': {
          '&.swiper-shadow--left:before, &.swiper-shadow--right:after': {
            bottom: muiTheme.spacing(6),
          },
        },
      },
      [muiTheme.breakpoints.up('md')]: {
        marginTop: muiTheme.spacing(-12),
        zIndex: 1,
        width: '100%',
        '& .swiper-container': {
          paddingTop: muiTheme.spacing(12),
          '&.swiper-shadow': {
            '&.swiper-shadow--left:before, &.swiper-shadow--right:after': {
              top: muiTheme.spacing(12),
              bottom: '0 !important',
            },
          },
        },
        '& div.swiper-carousel-footer': {
          position: 'absolute',
          top: muiTheme.spacing(1.5),
          right: 0,
          justifyContent: 'flex-end',
          margin: 0,
        },
      },
    },
    sliderNavigation: {},
  }),
  { name: 'CardListSlider' },
);

export default useCardListSliderStyles;
